import React,{useRef, useState, useEffect, useContext}	from "react";
import {X, CircleNotch}						from "@phosphor-icons/react";
import layerEvents							from "../utils/layerEvents";
import atlasApi								from "../utils/atlasapi";
import { Col, Row}							from "react-bootstrap";
import EditableRange						from "../components/EditableRange";

import {formatWindSpeed}					from "../utils/functions";
import globalContext						from "../utils/globalContext";
import {getCogApiKey}						from "../utils/tilesConfig";

const defaultOpacity = .5;
const defaultTicks = [6, 6.5, 7, 7.5, 8];

const gradient100 = 'linear-gradient(90deg,rgba(255, 255, 255, 1) 0%, rgba(99, 68, 137, 1) 25%, rgba(251, 251, 2, 1) 52%, rgba(255, 53, 0, 1) 77%, rgba(112, 36, 36, 1) 100%)';
const gradientDefault = 'linear-gradient(90deg,rgba(255, 255, 204, 1) 0%, rgba(128, 0, 0, 1) 100%)';

const mapproxyUrl = (layerName) => 'https://vindrtech.com/mapproxy/service?layer='+layerName+'&style=&tilematrixset=webmercator&Service=WMTS&Request=GetTile&Version=1.0.0&Format=png&TileMatrix={z}&TileCol={x}&TileRow={y}';

// De bulgarske vindkartene serveres av API-ets egen COG-flisserver fra
// rasterkontoen, ikke av mapproxy. Nøkkelen kommer fra det innloggede
// config-endepunktet, så URL-en kan først bygges når AuthGate har hentet den —
// derfor er datasettene en funksjon og ikke en konstant.
// REACT_APP_BG_WIND_TILES_URL overstyrer fortsatt, for lokalt genererte fliser.
const bgTilesUrl = (h) => process.env.REACT_APP_BG_WIND_TILES_URL
	? process.env.REACT_APP_BG_WIND_TILES_URL.replaceAll('{h}', h)
	: `${atlasApi.cogTilesEndpoint('bulgaria_'+h)}?token=${encodeURIComponent(getCogApiKey())}`;

const makeDataset = (label, windQuery, tileUrl, gradient, ticks) => ({
	label,
	windQuery,
	gradient,
	ticks,
	layer:{
		source : {
			id:'wind-raster',
			type: 'raster',
			'tiles': [ tileUrl ],
			tileSize: 256
		},
		layer:{
			id: "wind-layer",
			type: "raster",
			source: "wind-raster",
			paint: {
				'raster-opacity' : defaultOpacity
			}
		},
	}
});

const defaultDatasets = () => [
	makeDataset('100m', '100', mapproxyUrl('wind_map'), gradient100, defaultTicks),
	makeDataset('150m', '150', mapproxyUrl('wind_map_150m'), gradientDefault, defaultTicks),
	makeDataset('200m', '200', mapproxyUrl('wind_map_200m'), gradientDefault, defaultTicks)
];

const datasetsByCountry = {
	'Bulgaria': () => [
		makeDataset('100m', '100', bgTilesUrl('100m'), gradient100, defaultTicks),
		makeDataset('150m', '150', bgTilesUrl('150m'), gradientDefault, defaultTicks),
		makeDataset('200m', '200', bgTilesUrl('200m'), gradientDefault, defaultTicks)
	]
};

const getDatasets = (country) => (datasetsByCountry[country] || defaultDatasets)();

var t;
var windroses = {};

export default function OverlayWind({onClose}) {

	const rose								= useRef(null);
	const gradient							= useRef(null);
	const context							= useContext(globalContext);
	const tc								= context.tc;
	const projectid							= context.getters.project.projectid;
	const country							= context.getters.project.country;
	// Memoisert: URL-ene inneholder flisnoekkelen, og et nytt objekt per
	// render ville byttet ut kartlaget hver gang komponenten tegnes om.
	const datasets							= React.useMemo(() => getDatasets(country), [country]);

	const [activeLayer, setActiveLayer]		= useState(datasets[0]);
	const [opacity, setOpacity]				= useState(defaultOpacity*100);
	const [windrose, setWindrose]			= useState("/images/windrose.png");
	
	
		

	useEffect(() => {
		remLayer(datasets[0]);
		addLayer(datasets[0]);
		clearTimeout(t);
		loadWindrose();
		return () => {
			remLayer(activeLayer);
			clearTimeout(t);
		}
	}, []);

	const loadWindrose = () => {
		if(windroses[projectid])
			setWindrose(windroses[projectid]);
		else {
			atlasApi.getWindRose(projectid).then((r)=>{
				windroses[projectid] = URL.createObjectURL(r);
				setWindrose(windroses[projectid]);
			});
		}
	}

	const handleHeightChange = (e) => {


		remLayer(activeLayer);

		setActiveLayer(datasets[e.target.value]);

		addLayer(datasets[e.target.value]);

		handleOpacityChange(opacity);
	}
	const handleClick = (e) => {

		const val = gradient.current.querySelector(".value");
		
		val.classList.add("loading");

		atlasApi.getWindSpeed(activeLayer.windQuery, e.lngLat.lat, e.lngLat.lng ).then((r)=>{
			
			
			val.querySelector("span").innerHTML = formatWindSpeed(r.windspeed);
			
			val.classList.remove("loading");
			
			const p = convertPadding(r.windspeed);
			val.style.left =p+'px';
			val.classList.toggle("right", p>180 ? true : false);
			val.classList.toggle("center", p>65 && p<=180 ? true : false);
		});
		
	}
	const handleOpacityChange = (opc) => {
		setOpacity(opc);
		setLayerOpacity(activeLayer.layer.layer.id, opc);
	}
	const setGetter = (e)=>{
		
		clearTimeout(t);
		
		t = setTimeout(()=>handleClick(e), 500);
	}
	const addLayer = (ol) => {
		
		if(!tc.map.getSource(ol.layer.source.id)){
			tc.map.addSource(ol.layer.source.id, ol.layer.source);

			//set the opacity if there is a preset
			tc.map.addLayer(ol.layer.layer);
			

//			setTimeout(()=>{
//				this.gradient.current.style.background=this.activeLayer.gradient;
//				this.parent.forceUpdate();
//			},100);			
			tc.map.on('click', handleClick);
			tc.map.on('mousemove', setGetter);

			//tc.map.moveLayer(this.activeLayer.layer.layer.id, 'project-geojson-fill');	
		
		}
	}
	const remLayer = (ol) => {
		
		if(!tc.map.getSource(ol.layer.source.id))
			return;
		

		if(tc.map.getLayer(ol.layer.layer.id))
			tc.map.removeLayer(ol.layer.layer.id);
		
		tc.map.removeSource(ol.layer.source.id);
		
		tc.map.off("click", handleClick);
		tc.map.off("mousemove", setGetter);
		
	}
	const convertPadding = (value) => {
		
		var p = value-6;
		if(p<0)
			p=0;
		if(p>2)
			p=2;
		
		
		// 0->2 === 0->245px 
		p = (p*122.5);
		return p;
		
	}
	const setLayerOpacity = (l, opacity) => {
		if(l && opacity !== null){
			var opc = parseFloat(opacity);
			var layer = tc.map.getLayer(l);
			//console.log(layer.type);
			if(!layer)
				return;
			
			if (layer.type === 'symbol')  {
				tc.map.setPaintProperty(l, 'icon-opacity', opc);
				tc.map.setPaintProperty(l, 'text-opacity', opc);
			}
			else if(layer.type === 'raster') {
				tc.map.setPaintProperty(l, layer.type+'-opacity', opc);
			}
			else {
				var op = ['case',
					['boolean', ['feature-state', 'invisible'], false],0,
					opc
				];
				tc.map.setPaintProperty(l, layer.type+'-opacity', op);
			}
		}
	}
		

	return (
		<div className="card overlayWind">
			<div className="row title">
				Wind map
				<span onClick={(e)=>{onClose();}} className="btn btn-close btn-sm float-end"><X  size={12} weight="bold" /></span>
			</div>
			<Row className="height-selector">
				<Col xs="6">
					Height

				</Col>
				<Col xs="6" className="text-right">

					<select className="branded-select form-select" onChange={handleHeightChange}>
					{
						datasets.map((l, j)=>{
							return <option value={j}>{l.label}</option>
						})
					}
					</select>
				</Col>
			</Row>
			<div className="windrose text-center">
				<img ref={rose} src={windrose} width="250" height="250" />
			</div>
			<div className="scale">



				<div ref={gradient} className="gradient">
					<div className="value">
						<span>0 m/s</span>
						<CircleNotch  size={16} />
					</div>
				</div>
				<div className="ticks">
				{
					activeLayer.ticks.map((v)=>{return <div className="tick"><div>{v}</div></div>})
				}
				</div>

			</div>
			<Row>
				<Col xs="12 style-name pt-2">
					Layer opacity (%)
				</Col>
				<Col xs="12">
					<EditableRange wrpClassName="mb-3" className="opacity-range-input" min="0" max="100" step="1" value={opacity} defaultValue={opacity} onChange={(e)=>{handleOpacityChange(e.target.value/100);}} />
				</Col>
			</Row>	
		</div>
	)
	
}